import React from 'react';
import PropTypes from 'prop-types';
import { AdUnit } from 'site-modules/shared/components/ad-unit/ad-unit';

export function CompareAd(props) {
  const { isMobile, position } = props;
  const adname = isMobile ? 'mcompare' : 'compare';
  return (
    <div className="compare-ad d-none">
      <AdUnit
        adName={adname}
        position={position}
        all
        renderWhenViewable={false}
        refreshable={false}
        showLabel={false}
        {...props}
      />
    </div>
  );
}

CompareAd.propTypes = {
  isMobile: PropTypes.bool,
  position: PropTypes.string,
};

CompareAd.defaultProps = {
  isMobile: false,
  position: '1',
};
